import { render, staticRenderFns } from "./pbbadjust.vue?vue&type=template&id=76f4f1d4"
import script from "./pbbadjust.vue?vue&type=script&lang=js"
export * from "./pbbadjust.vue?vue&type=script&lang=js"
import style0 from "./pbbadjust.vue?vue&type=style&index=0&id=76f4f1d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports